import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import '../../../../../styles/components/bidders-list.scss';
import { formatDate, getAvatarColor, getInitials } from '../../../../../utils/common';
import { Award, Crown, Medal, Star } from 'lucide-react';

export class BiddersList extends React.Component {
  handleCancel = () => {
    this.props.onClose();
  };

  getRankBadge = (index, isWinner) => {
    if (isWinner) {
      return (
        <span className="rank-badge winner">
          <Crown size={14} strokeWidth={1.5} /> Winner
        </span>
      );
    }

    const rank = index + 1;
    if (rank === 1)
      return (
        <span className="rank-badge rank-1">
          <Medal size={14} strokeWidth={1.5} /> 1st
        </span>
      );
    if (rank === 2)
      return (
        <span className="rank-badge rank-2">
          <Award size={14} strokeWidth={1.5} /> 2nd
        </span>
      );
    if (rank === 3)
      return (
        <span className="rank-badge rank-3">
          <Star size={14} strokeWidth={1.5} /> 3rd
        </span>
      );
    return <span className="rank-badge rank-other">#{rank}</span>;
  };

  formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'OMR',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  render() {
    const { show, bidders = [] } = this.props;

    return (
      <CustomModal isOpen={show} header={`Bidders List`} onClose={this.handleCancel}>
        <div className="bidders-container">
          {bidders.length === 0 ? (
            <div className="no-bidders">
              <p>No bidders yet</p>
            </div>
          ) : (
            <div className="bidders-list">
              {bidders.map((bidder, index) => (
                <div
                  key={bidder.id}
                  className={`bidder-card ${bidder.winner ? 'winner-card' : ''}`}
                >
                  <div className="bidder-rank">{this.getRankBadge(index, bidder.winner)}</div>

                  <div className="bidder-content">
                    <div className="bidder-avatar-section">
                      <div
                        className="bidder-avatar"
                        style={{ backgroundColor: getAvatarColor(bidder.user_id) }}
                      >
                        {getInitials(bidder.user?.name)}
                      </div>
                      <div className="bidder-info">
                        <h3 className="bidder-name">{bidder.user?.name || 'Unknown'}</h3>
                        <div className="bidder-meta">
                          <span className="bidder-id">ID: {bidder.user_id}</span>
                          <span className="bidder-separator">•</span>
                          <span className="bid-id">Bid #{bidder.id}</span>
                        </div>
                        <div className="bidder-contact">
                          <span className="bidder-email">{bidder.user?.email}</span>
                        </div>
                      </div>
                    </div>

                    <div className="bidder-amount-section">
                      <div className="bid-amount">{this.formatAmount(bidder.bid_amount)}</div>
                      <div className="bid-date">{formatDate(bidder.created_at)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {bidders.length > 0 && (
            <div className="bidders-footer">
              <p>
                Total Bidders <strong>{bidders.length}</strong>
              </p>
            </div>
          )}
        </div>
      </CustomModal>
    );
  }
}
